import React from 'react';
import { Box, Chip, Grid, Typography } from '@mui/material';
import Card from '../common/Card';
import Button from '../common/Button';

const statusColor = {
  OK: 'success',
  WARN: 'warning',
  ERROR: 'error',
};

const EngineStatusCard = ({ data, loading, onRefresh }) => {
  const signal = data?.signal || {};
  const risk = data?.risk || {};
  const execution = data?.execution || {};

  return (
    <Card
      title="Engine Status"
      actions={(
        <Button variant="contained" size="small" onClick={onRefresh} loading={loading}>
          Refresh
        </Button>
      )}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Typography variant="caption" color="text.secondary">Status</Typography>
          <Box sx={{ mt: 0.5 }}>
            <Chip
              size="small"
              label={data?.status || 'UNKNOWN'}
              color={statusColor[data?.status] || 'default'}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography variant="caption" color="text.secondary">Signal</Typography>
          <Typography variant="body1" sx={{ mt: 0.5 }}>
            {signal.signal || '-'} ({signal.trend || '-'})
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography variant="caption" color="text.secondary">Confidence</Typography>
          <Typography variant="body1" sx={{ mt: 0.5 }}>
            {Number(signal.confidence || 0)}%
          </Typography>
        </Grid>

        <Grid item xs={12} md={4}>
          <Typography variant="caption" color="text.secondary">Risk Level</Typography>
          <Typography variant="body1" sx={{ mt: 0.5 }}>
            {risk.level || '-'}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography variant="caption" color="text.secondary">Execution Action</Typography>
          <Typography variant="body1" sx={{ mt: 0.5 }}>
            {execution.action || '-'}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography variant="caption" color="text.secondary">Updated At</Typography>
          <Typography variant="body1" sx={{ mt: 0.5 }}>
            {data?.updatedAt ? new Date(data.updatedAt).toLocaleString() : '-'}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
};

export default EngineStatusCard;
